// extracted by mini-css-extract-plugin
export var dot = "_qs-2";
export var wave = "_qs-0";
export var waveSmall = "_qs-1";